import api from '../../api'
import _mapChildren from "../../utils/mapChildren";

const state = {
    all: [],
};

// getters
const getters = {
};

// actions
const actions = {
    //Get all themes
    _getThemes ({ commit, rootState, state, getters }, params) {
        if(typeof params.query === "undefined"){
            params.query = {};
        }
        return new Promise((resolve, reject)=> {
            //Check if request needs to be done
            if (typeof params.forceUpdate === "undefined") {
               params.forceUpdate = true;
            }
            if (state.all.length === 0 || params.forceUpdate) {
                //Als include the associate user group and role
                params.query.include = "user,groups,role";
                api
                    .get(rootState.team + '/topics', {params: params.query})
                    .then(response => {
                        let themes = response.data.data;
                        //If it is data for a table. Uncheck the top checkbox
                        if(document.getElementById("checkAll")){
                            document.getElementById("checkAll").checked = false;
                        }
                        //To map children
                        let newArray = [];
                        themes.forEach(item=>{
                            newArray = newArray.concat(_mapChildren(item));
                        });

                        themes = newArray;
                        commit('_setThemes', themes);
                        console.log(themes);
                        if(params.onlyModel){
                            resolve(themes);
                        }
                        else{
                            resolve({data: {data: themes, _pagination: response.data._pagination}});
                        }
                    }).catch(error => {
                        reject();
                        console.error(error);
                    });
            }
        });
    },
    _createTheme ({ commit, rootState, dispatch }, theme) {
        return new Promise((resolve, reject)=>{
            //Map data to be valid for the api call
            if(typeof theme.parent !== "undefined" && typeof theme.parent.uuid !== "undefined"){
                theme.parent = theme.parent.uuid;
            }
            api
                .post(rootState.team+'/topics', theme)
                .then(response => {
                    dispatch('toasts/_addToast', {text: "Theme added"}, {root:true})
                    resolve(response);
                }).catch(error =>{
                    reject(error.response.data.error.exception[0].message);
                });
        });
    },
    _updateTheme ({ commit, dispatch }, theme) {
        return new Promise((resolve, reject)=>{
            if(typeof theme.parent.uuid !== "undefined"){
                theme.parent = theme.parent.uuid;
            }
            api
                .put('/topics/'+theme.uuid, theme)
                .then(response => {
                    dispatch('toasts/_addToast', {text: "Theme updated"}, {root:true})
                    console.log(response);
                    resolve();
                }).catch(error =>{
                console.error(error);
                reject(error.response.data.error.exception[0].message);
            });
        });

    },
    _deleteThemes ({ commit, dispatch }, themes) {
        return new Promise((resolve, reject)=>{
            let themesUuids = null;
            if(Array.isArray(themes)){
                themesUuids = themes.map(theme=>{
                    return theme.uuid;
                }).join(",")
            }
            else{
                themesUuids = themes.uuid;
            }
            api
                .delete('/topics/'+themesUuids)
                .then(response => {
                    dispatch('toasts/_addToast', {text: "Group deleted"}, {root:true})
                   resolve();
                }).catch(error =>{
                console.error(error.response);
                reject(error.response.data.error.exception[0].message);
            });
        });
    },
};


// mutations
const mutations = {
    _setThemes(state, themes){
        state.all = themes;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
